import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { bloquearChat } from '../../actions/chat';

// Reemplaza la caja de escribir cuando YO bloqueé a la otra persona: explica lo que pasa y deja desbloquear ahí mismo.
const AvisoBloqueo = ({ chatId, nombre }) => {
  const dispatch = useDispatch();
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState('');

  const desbloquear = async () => {
    setEnviando(true);
    setError('');
    const r = await dispatch(bloquearChat(chatId, false));
    setEnviando(false);
    if (!r.ok) setError(r.error);
  };

  return (
    <Box sx={{ p: 2, bgcolor: 'white', borderTop: 1, borderColor: 'sutil' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
        <BlockOutlinedIcon sx={{ color: 'error.oscuro', flexShrink: 0 }} />
        <Typography variant="body2" sx={{ flex: 1, minWidth: 160, color: 'text.secondary' }}>
          Bloqueaste a {nombre || 'esta persona'}. Mientras tanto no pueden escribirse.
        </Typography>
        <Button size="small" variant="outlined" onClick={desbloquear} disabled={enviando} sx={{ textTransform: 'none', borderRadius: 2 }}>
          {enviando ? 'Desbloqueando…' : 'Desbloquear'}
        </Button>
      </Box>
      {error && <Typography role="alert" variant="caption" sx={{ display: 'block', mt: 0.5, color: 'error.oscuro' }}>{error}</Typography>}
    </Box>
  );
};

AvisoBloqueo.propTypes = {
  chatId: PropTypes.string,
  nombre: PropTypes.string,
};

export default AvisoBloqueo;
